import { Badge, Group, Text } from "@mantine/core";
import { useTranslation } from "../../hooks/useTranslation";

interface FoundCountBadgeProps {
    count: number;
    singularNoun: string;
    pluralNoun: string;
}

/**
 * "Found N {noun}" summary badge — the shared core of CV list's SearchResultsSummary, extracted
 * so any list surface renders an identical result-count summary. Each feature wraps this with its
 * own extra state (filtered-badge, applied-filter matches, search errors, loading text, etc.) as
 * needed — this component only ever renders the count itself.
 */
export function FoundCountBadge({ count, singularNoun, pluralNoun }: FoundCountBadgeProps) {
    const { t } = useTranslation();
    return (
        <Group gap={6} align="center">
            <Text size="sm" c="dimmed">{t("COMMON_FOUND", undefined, "Found")}</Text>
            <Badge size="lg" variant="filled" color="brand.5">
                {count}
            </Badge>
            <Text size="sm" c="dimmed">{count === 1 ? singularNoun : pluralNoun}</Text>
        </Group>
    );
}
